import { render, staticRenderFns } from "./SalaryData.vue?vue&type=template&id=3b697ff2&scoped=true"
import script from "./SalaryData.vue?vue&type=script&lang=js"
export * from "./SalaryData.vue?vue&type=script&lang=js"
import style0 from "./SalaryData.vue?vue&type=style&index=0&id=3b697ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b697ff2",
  null
  
)

export default component.exports